import React from 'react';
import clsx from 'clsx';
import styles from './NonDismissibleOverlay.module.scss';
export const NonDismissibleOverlay = ({ backgroundOpacity, children })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.root, styles[backgroundOpacity])
    }, backgroundOpacity == 'translucent' ? /*#__PURE__*/ React.createElement("div", {
        className: styles.card
    }, children) : children);
